export const freeShippingLimit = 200;
export const productCacheExpiration = 3600000; // in milliseconds
export const fixedShippingCharge = 20;
